
export class ITipoMinutaAM {
    codigo: string;
    descricao: string;

    static retornaTipoMinutaAMPelaDescricao(descricao: string) {
        if (descricao === VotoAM.descricao) {
            return VotoAM;
        } else if (descricao === DespachoAM.descricao) {
            return DespachoAM;
        } else if (descricao === DecisaoAM.descricao) {
            return DecisaoAM;
        } else {
            return undefined;
        }
    }
    
    static retornaTipoMinutaAMPeloCodigo(codigo: string) {
        if (codigo === VotoAM.codigo) {
            return VotoAM;
        } else if (codigo === DespachoAM.codigo) {
            return DespachoAM;
        } else if (codigo === DecisaoAM.codigo) {
            return DecisaoAM;
        } else {
            return undefined;
        }
    }
}

class VotoAm implements ITipoMinutaAM {
    codigo = 'VTRELTR';
    descricao: string = 'Voto Relator'
}

class DespachoAm implements ITipoMinutaAM {
    codigo = 'DESP';
    descricao: string = 'Despacho'
}

//TODO resolver como fazer isso no banco do AM
class DecisaoAm implements ITipoMinutaAM {
    codigo = 'DECI';
    descricao: string = 'Decisao'
}

export const DespachoAM = new DespachoAm();
export const DecisaoAM = new DecisaoAm();
export const VotoAM = new VotoAm();
 